<template>
    <div>
        <div v-if="showConnecting" style="width: 100%; text-align: center">
            <div>Connecting to signal server...</div>
            <b-spinner large label="Connecting to signal server..." />
        </div>

        <b-table-simple
            class="mt-2"
            table-variant="light"
            striped
            borderless
            small
        >
            <b-thead>
                <b-tr>
                    <b-th>Session Name</b-th>
                    <b-th>Peers</b-th>
                    <b-th>Recording</b-th>
                </b-tr>
            </b-thead>

            <b-tbody>
                <b-tr v-for="session in serverSessions" :key="session.id">
                    <b-td>
                        {{ session.name }}
                        <div><a :href="`/recordings/${session.id}`" class="small">{{ session.id }}</a></div>
                        <b-button
                            variant="danger"
                            @click="joinSession(session.id)"
                            >Join session - use with care!!</b-button
                        >
                    </b-td>
                    <b-td>
                        {{ session.peers.length }}
                        <b-table-simple
                            table-variant="light"
                            striped
                            small
                            bordered
                        >
                            <b-tbody>
                                <b-tr
                                    v-for="peer in session.peers"
                                    :key="peer.id"
                                >
                                    <b-td
                                        :class="{
                                            recording:
                                                peer.peerState.isRecording,
                                        }"
                                    >
                                        {{ peer.displayName }} ({{
                                            peer.hostNumber
                                        }}) {{ peer.isHost ? "*" : "" }}

                                        <img
                                            v-if="peer.peerState.isMicCut"
                                            src="@/assets/images/micCut.svg"
                                            style="height: 20px"
                                            class="img-fluid micCutIcon"
                                            alt="Mic Muted"
                                        />

                                        <div class="small">
                                            {{ peer.peerState.audioDevice }}
                                        </div>
                                    </b-td>

                                    <b-td>
                                        {{ formatDateTime(peer.connectTime) }}
                                    </b-td>

                                    <b-td>
                                        <div>{{ peer.ipAddress }}</div>
                                        <div class="small">
                                            {{ peer.userAgent }}
                                        </div>
                                    </b-td>
                                    <b-td>v{{ peer.peerState.version }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-td>
                    <b-td>{{ session.isRecording }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<style scoped>
    .recording {
        color: red;
    }
</style>

<script>
import SignalServer from "../services/SignalServer";
import { getToken } from "../services/JwtService";
import { formatDateTime } from "../utils";

export default {
    data() {
        return {
            error: "",
            showError: false,
            serverSessions: [],
            isSignalServerConnected: false,
        };
    },

    computed: {
        showConnecting() {
            return !this.isSignalServerConnected;
        },
    },

    methods: {
        initialiseSignalServer() {
            this.signalServer = new SignalServer({
                name: "Signal Server",
                server: process.env.VUE_APP_SIGNAL_SERVER,
                path: process.env.VUE_APP_SIGNAL_PATH,
            });

            this.signalServer.connect(getToken());

            this.signalServer.on("AUTHORISED", () => {
                this.isSignalServerConnected = true;
            });

            this.signalServer.on("UNAUTHORISED", () => {
                this.isSignalServerConnected = false;
                this.setError("Unauthorised to connect to signal server");
            });

            this.signalServer.on("DISCONNECTED", () => {
                this.isSignalServerConnected = false;
            });
        },

        async getServerSessions() {
            try {
                this.serverSessions = await this.signalServer.get(
                    "GET_SERVER_SESSIONS"
                );
                console.log(this.serverSessions);
            } catch (err) {
                console.warn(err);
            }

            setTimeout(this.getServerSessions.bind(this), 3000);
        },

        formatDateTime: formatDateTime,

        joinSession(id) {
            this.$store.dispatch("joinSession", id);
            this.$router.push("host");
        },
    },

    async beforeMount() {
        this.initialiseSignalServer();
        this.getServerSessions();
    },
};
</script>